module.exports = __webpack_public_path__ + "static/007-991505899be3a97282dde748d1535375.png";